import { cn } from "@/lib/utils";

const STATUS_COLORS = {
  todo: "bg-status-todo",
  wip: "bg-status-wip",
  review: "bg-status-review",
  done: "bg-status-done",
  waiting: "bg-status-waiting",
} as const;

export type Status = keyof typeof STATUS_COLORS;

export function StatusDot({
  status,
  className,
  size = 10,
}: {
  status: Status;
  className?: string;
  size?: number;
}) {
  return (
    <span
      className={cn(
        "inline-block rounded-full",
        STATUS_COLORS[status],
        className,
      )}
      style={{ width: size, height: size }}
      aria-label={`status ${status}`}
    />
  );
}
